// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Agents extends APIResource {
    /**
     * Retrieves all agents associated with the specified block. Raises a 404 if the
     * block does not exist.
     */
    list(blockID, query = {}, options) {
        return this._client.getAPIList(path `/v1/blocks/${blockID}/agents`, (ArrayPage), {
            query,
            ...options,
        });
    }
}
//# sourceMappingURL=agents.mjs.map